import type { RoleCaseTask } from "@/components/Forms/SubForms/AssignTaskByRoleForm.tsx";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import {
    type MRT_ColumnDef,
    type MRT_Row,
    MaterialReactTable,
    useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";

type Props = {
    tasksToCreate: RoleCaseTask[];
    setTasksToCreate: (tasksToCreate: RoleCaseTask[]) => void;
};

const MrtAssignTasksImpactedUsers = ({ tasksToCreate, setTasksToCreate }: Props) => {
    const columns = useMemo<MRT_ColumnDef<RoleCaseTask>[]>(
        () => [
            {
                accessorKey: "role",
                header: "Role",
                size: 50,
            },
            {
                accessorKey: "case.name",
                header: "Case",
            },
            {
                accessorKey: "taskTemplate.name",
                header: "Template",
            },
            {
                accessorKey: "duration",
                header: "Duration",
            },
            {
                accessorKey: "delete",
                header: "Delete",
                size: 50,
                Cell: ({ row }) => (
                    <IconButton
                        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                            event.stopPropagation();
                            handleDeleteRow(row);
                        }}
                    >
                        <DeleteIcon />
                    </IconButton>
                ),
            },
        ],
        [],
    );

    const handleDeleteRow = (row: MRT_Row<RoleCaseTask>) => {
        if (window.confirm("Are you sure you want to delete this Task?")) {
            const newTasks = tasksToCreate.filter((task) => task !== row.original);
            setTasksToCreate(newTasks);
        }
    };

    const table = useMaterialReactTable({
        columns,
        data: tasksToCreate,
        initialState: {
            showColumnFilters: false,
            showGlobalFilter: true,
            density: "compact",
        },

        // top toolbar
        enableTopToolbar: false,
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        enableHiding: false,
        enableColumnFilters: false,

        rowCount: tasksToCreate.length ?? 0,
    });

    return <MaterialReactTable table={table} />;
};

export default MrtAssignTasksImpactedUsers;
